// extracted by mini-css-extract-plugin
export default {"helpText":"HelpLink_helpText__4YqGd"};